module.exports = __webpack_public_path__ + "fa-brands-400.ed311c7a0ade9a75bb3e.woff2";


//////////////////
// WEBPACK FOOTER
// F:/node/angular/complejidadesFrontend/~/@fortawesome/fontawesome-free/webfonts/fa-brands-400.woff2
// module id = ../../../../@fortawesome/fontawesome-free/webfonts/fa-brands-400.woff2
// module chunks = 2